import Cookies from "js-cookie";

const COOKIE_NAME = "callahan_user_id";

export const getUserId = () => {
  let userId = Cookies.get(COOKIE_NAME);

  // If no cookie exists, create a new one with a unique ID
  if (!userId) {
    userId =
      "user_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
    Cookies.set(COOKIE_NAME, userId, { expires: new Date("2099-12-31") });
  }

  return userId;
};

export const computeRank = (video, pool) => {
  const sorted = [...pool].sort((a, b) => (b.elo || 1000) - (a.elo || 1000));
  return {
    rank: sorted.findIndex((v) => v.id === video.id) + 1,
    total: sorted.length,
  };
};
